import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Body {
  accountId: string;
  employeeId: string;
  paymentMethodId: string;
  returnType: string;
}
const useCloseCIPQuery = () => {
  const { mutateAsync, isLoading } = useMutation((body: Body) =>
    api.post(API_URL.ACCOUNTS_CLOSE, {
      account_id: _.toNumber(body.accountId),
      employee_id: _.toNumber(body.employeeId),
      payment_method_id: _.toNumber(body.paymentMethodId),
      return_type: body.returnType,
    })
  );

  const handleSave = useCallback(
    async (body: Body) => {
      await mutateAsync(body);
    },
    [mutateAsync]
  );
  return {
    handleSave,
    isLoading,
  };
};
export default useCloseCIPQuery;
